import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { VenueCustomerFacilitiesFieldsComponent } from './venue-customer-facilities-fields.component';
import { VenueCustomerProfileFieldsComponent } from './venue-customer-profile-fields.component';

@NgModule({
  declarations: [VenueCustomerProfileFieldsComponent, VenueCustomerFacilitiesFieldsComponent],
  imports: [CommonModule, ReactiveFormsModule, DropdownModule, MultiSelectModule],
  exports: [VenueCustomerProfileFieldsComponent, VenueCustomerFacilitiesFieldsComponent]
})
export class VenueCustomerProfileFieldsModule {}
